export const serverError = (text: string, e: any) => {
    if (e?.status === 423) {
        let response = e?.response;
        if (typeof response === "string") {
            try {
                response = JSON.parse(response);
            } catch {
                return text;
            }
        }

        const message = response?.message;
        return typeof message === "string" && message.trim() ? message : text;
    }

    const message = e?.message ? e.message : "";
    const status = e?.status ? ", " + e.status : "";
    const response = e?.response?.message ? ": " + e.response.message : "";
    return text + ", " + message + status + response;
};
